export const TOGGLE_EVENT_NAME = 'toggle'
export const TEST_ID = 'base-accordion'
